module.exports = __webpack_public_path__ + "img/Illustration-motion-bank.034a00a4.png";